
import {
  GET_CONTROL_SHEET_ADVANCESHIP_LOG_REQUEST,
  GET_CONTROL_SHEET_ADVANCESHIP_LOG_SUCCESS,
  GET_CONTROL_SHEET_ADVANCESHIP_LOG_ERROR
} from "../actions/types";

export default function (state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case GET_CONTROL_SHEET_ADVANCESHIP_LOG_REQUEST:
      return {
        loading: true,
      };
    case GET_CONTROL_SHEET_ADVANCESHIP_LOG_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_CONTROL_SHEET_ADVANCESHIP_LOG_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};